export const projects = [
    {
      title: "Easy Travel",
      subtitle: "Java Application (JDK 11)",
      description:
        "A Java Application made as part of a school project. The application aims to help make travel planning easy through the use of commands and time keeping",
      image: "./images/projects/EasyTravel.png",
      link: "https://ay1920s2-cs2103t-w17-3.github.io/main/",
      width: "500",
      height: "400"
    },
    {
      title: "Yuri Bot",
      subtitle: "Java Application (JDK 11)",
      description:
        "A Simple Java Bot made as part of a school project. Yuri is a bot with a unique personaility that keeps track of your events and deadlines through the use of commands",
      image: "./images/projects/yuri-bot.jpeg",
      link: "https://deunitato.github.io/duke/",
      width: "500",
      height: "400"
    },
    {
      title: "Doki Doki Computer Club",
      subtitle: "Python (Ren'py)",
      description:
        "A simple visual novel game made during a 24-hour hackaton project. This project won the best freshman hack.",
      image: "./images/projects/dokidokicc.gif",
      link: "https://devpost.com/software/doki-doki-computer-club",
      width: "500",
      height: "400"
    },
    {
      title: "B1ForGod Google Calender Telegram Bot",
      subtitle: "Python, Google API",
      description:
        "A side project for my church. The telegram bot is to help members of my church add and keep track of events in a shared calender",
      image: "./images/projects/b1ForGod.gif",
      link: "https://github.com/Deunitato/Project-B1ForGod",
      width: "400",
      height: "350"
    },
    {
      title: "Project Covid",
      subtitle: "Python, Flask, CC2650 Sensor tag",
      description:
        "Part of a school project in NUS, Project Covid is a web game that uses the CC2650 Sensor tag and machine learning to determine the player's move. The main objective of the game is to swing or slash using the sensor tag in order to defeat the villan of the game, Covid",
      image: "./images/projects/covid-gameplay.gif",
      link: "https://github.com/Deunitato/CS3237-Project-COVID",
      width: "400",
      height: "350"
    },
    {
      title: "PIExam",
      subtitle: "Python, Shell script, RaspberryPI3",
      description:
        "Part of a school project in NUS, PIExam is a exam recording software/script that was built using the RaspberryPI. The idea is to use the RaspberryPI to record and conduct exams while keeping track of the user's internet access and ports used. After the exam, the answers and the student's netcat log would be sent to the teacher.",
      image: "./images/projects/PiExam.gif",
      link: "https://github.com/Deunitato/CS3103-Project-Group-11-PIExam",
      width: "400",
      height: "350"
    },
    {
      title: "Dspace7 Kubernetes",
      subtitle: "AKS, Kubernetes",
      description:
        "As part of my Internship at Data4Life, I was task on researching and implementing Dspace7 on AKS (Azure Kubernetes Service). Since Dspace7 at the time does not have any helm charts available, this project was quite tough and challenging. However, I manage to build a MVP using Azure Kubernetes service that was provided in my internship",
      image: "./images/projects/dspace-map.png",
      link: "https://github.com/Deunitato/Dspace7-Kubernetes",
      width: "400",
      height: "350"
    },
    {
      title: "Advance Manufacturing Pursuits - Darf Sensor",
      subtitle: "Android, C++, STM32L053 Nucleo Board",
      description:
        "Part of a joint Final Year Project in Singapore Polytechnic. DARF stands for Database, Advance RISC Machine (ARM) Processor and Radio Frequency Identification. Darf Sensor aims to automate easy barcode detection and tracking of goods in a manfucatoring environement. Read more to find out.",
      image: "./images/projects/darf-sensor.JPG",
      link: "https://www.linkedin.com/in/charlottelimwt/details/featured/1582731623567/single-media-viewer/",
      width: "400",
      height: "350"
    },
  ];